/**
 * GA4 event tracking helpers for music sites.
 *
 * Wraps window.gtag() with null-safety — no-ops when gtag is undefined
 * (dev/test environments, or sites without a GA4 tag). The site's existing
 * client-side gtag (shared/_google_tag) provides window.gtag in production.
 */

function sendToGtag(...args) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag(...args)
  }
}

export function trackLinkClick(platform, kind) {
  sendToGtag("event", "music_link_click", {
    platform: platform,
    kind: kind,
  })
}
